import { Trans } from 'react-i18next';
import classNames from 'classnames';
import { useHeaderContext } from '@components/HeaderContext';
import { PageComponent } from '@root/pages/Type';
import { SuccessIcon } from '@components/Ui/Icons/Index';
import styles from './style.module.scss';
import useTimeAction from '@root/utils/useTimeAction';
import { useSelector } from 'react-redux';
import { RootState } from '@root/store/types';
import { Router as i18nRouter } from '@root/router';
import { useEffect } from 'react';

const Success: PageComponent = () => {
    const currentLanguage = useSelector(
        (state: RootState) => state.i18n.currentLanguage,
    );
    const { isOpenPasswordReset } = useHeaderContext();
    const { timeoutsec } = useTimeAction(() => {
        i18nRouter.pushRoute('ui_services_list', {}, currentLanguage);
    }, 3000);
    useEffect(() => {
        i18nRouter.prefetchRoute('ui_services_list', currentLanguage);
    }, []);
    return (
        <div
            className={classNames(styles.login_container, {
                [styles.open_login]: isOpenPasswordReset,
            })}
        >
            <div className={styles.login_inner}>
                <div className="row">
                    <div className={`col-12 ${styles.login_success_container}`}>
                        <SuccessIcon />
                        <h4>
                            <Trans i18nKey="success.title" ns="passwordReset">
                                Slaptažodžio priminimas
                            </Trans>
                        </h4>
                        <p>
                            <Trans
                                i18nKey="success.description"
                                ns="passwordReset"
                            >
                                Slaptažodis pakeistas sėkmingai.
                            </Trans>
                        </p>
                        <p>
                            <Trans
                                i18nKey="success.redirectText"
                                ns="passwordReset"
                                values={{ timeoutsec }}
                            >
                                Automatinis nukreipimas į vartotojo valdyma už
                                [[timeoutsec]] s.
                            </Trans>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Success;
